<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} đánh giá</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} đánh giá</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} đánh giá</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item label="Người đánh giá" prop="nguoi_check_in_id">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten_nguoi_checkin"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Đối tượng đánh giá" prop="loai_doi_tuong_danh_gia">
                <el-select
                  v-model="mData.dataForm.loai_doi_tuong_danh_gia"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listLoaiDoiTuongDanhGia"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <el-form-item label="Đối tượng đánh giá" prop="diem_den_an_toan_id">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten_diem_den_an_toan"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Đánh giá" prop="danh_gia.gia_tri">
                <el-input
                  type="text"
                  v-model="mData.dataForm.danh_gia.gia_tri"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Thời điểm tạo" prop="danh_gia.thoi_diem_tao">
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.danh_gia.thoi_diem_tao"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Nội dung" prop="danh_gia.noi_dung">
                <el-input
                  type="textarea"
                  :rows="6"
                  v-model="mData.dataForm.danh_gia.noi_dung"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>

          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Tiêu chí vi phạm">
                <el-checkbox-group v-model="mData.dataDefault.listThongTinThem">
                  <el-checkbox
                    v-for="item in mData.dataDefault.listThongTinThem"
                    :label="item"
                    :key="item"
                    disabled
                  >{{item}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import DanhGiaDDATDetailModel from "./DanhGiaDDATDetailModel";
import CheckinDDATApi from "../../../moduleApi/CheckinDDATApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
import TourApi from "../../../moduleApi/TourApi";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import DichVuChatLuongCaoApi from "../../../moduleApi/DichVuChatLuongCaoApi";
import NhomTPDanhGiaApi from "../../../moduleApi/NhomTPDanhGiaApi";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import CoSoLuuTruApi from "../../../moduleApi/CoSoLuuTruApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "DanhGiaDDATDetail",
        dataDefault: {
          roles: DataService.rolesInForm,
          listLoaiDoiTuongDanhGia: DanhGiaDDATDetailModel.loaiDoiTuongDanhGia,
          listThongTinThem: [],
        },
        dataForm: MethodService.copyObject(DanhGiaDDATDetailModel.dataForm),
        validForm: DanhGiaDDATDetailModel.validForm,
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await CheckinDDATApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await CheckinDDATApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {

      let res = await CheckinDDATApi.findById(id);

      let resTenNguoiDanhGia = await KhachDuLichApi.findById(res.result.nguoi_check_in_id);
      if (resTenNguoiDanhGia.result) {
        res.result.ten_nguoi_checkin = resTenNguoiDanhGia.result.ho_ten.ho_ten;
      } else {
        res.result.ten_nguoi_checkin = "";
      }

      let resDoiTuongDanhGia = await DiemDenAnToanApi.findById(res.result.diem_den_an_toan_id);
      res.result.ten_diem_den_an_toan = resDoiTuongDanhGia.result.thong_tin_chung.ten;

      if (res.result.danh_gia.thong_tin_them&&res.result.danh_gia.thong_tin_them.kpis&&res.result.danh_gia.thong_tin_them.kpis.length>0) {
        this.mData.dataDefault.listThongTinThem = res.result.danh_gia.thong_tin_them.kpis;
      }

      this.mData.dataForm = res.result;
      this.mData.dataForm.loai_doi_tuong_danh_gia = 'safe_place';
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    }
  },
  created: function() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>
